import angular from 'angular'
import ngRedux from 'ng-redux'
import { SaleManager } from '../../../managers/sale-manager'
import { selectSaleFinals } from '../../../state/slices/currentSale/currentSaleSlice'
import { Finals } from '../../../models/sale'
import { $q } from '../../../ng-compat/imports'

/**
 * Controller for the sale-tax-breakdown popover.
 *
 * @class SaleTaxBreakdownPopoverController
 */
export class SaleTaxBreakdownPopoverController {
  public saleFinals: Finals

  constructor(
    public close: () => void,
    public saleManager: SaleManager,
    private readonly $ngRedux: ngRedux.INgRedux,
    $scope: angular.IScope,
    private $q: angular.IQService
  ) {
    'ngInject'
    this.saleFinals = selectSaleFinals(this.$ngRedux.getState())
    const disconnect = this.$ngRedux.connect(state => ({
      saleFinals: selectSaleFinals(state),
    }))(this)
    $scope.$on('$destroy', disconnect)
  }

  /**
   * Remove all tax rates from the sale. Closes the popover if there are no tax rates to display once completed.
   *
   * @method removeAllTax
   *
   * @return {Promise} A promise resolved once all the tax rates have been removed from the sale
   */
  public removeAllTax() {
    return $q
      .when(this.saleManager.removeAllTax())
      .then(() => this._closeIfNoBreakdownToShow())
  }

  /**
   * Remove the given tax rate from the sale. Closes the popover if there are no tax rates to display once completed.
   *
   * @method removeTax
   *
   * @param  {Object} taxRate
   *         The tax rate to remove from the sale
   *
   * @return {Promise} A promise resolved once the given tax rate has been removed from the sale
   */
  public removeTax(taxRate: any) {
    return this.$q
      .when(this.saleManager.removeTax(taxRate))
      .then(() => this._closeIfNoBreakdownToShow())
  }

  /**
   * Close the popover if there is no longer a tax rate breakdown to display (i.e. because all tax rates have been
   * removed from the sale).
   *
   * @private
   * @method _closeIfNoBreakdownToShow
   */
  private _closeIfNoBreakdownToShow() {
    if (!this.saleFinals.taxDisplayProperties.showTaxBreakdown) {
      this.close()
    }
  }
}
